import map from "./map";
import toError from "./toError";

// [String] -> [Error]
const toErrors = map(toError);

export default toErrors;
